<template>
    <CustomMultiSelect :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                       :item-label="itemLabel" item-value="id" :label="label" v-if="!loading" :required="required"
                       :placeholder="placeholder" :noPlaceholder="noPlaceholder"/>
</template>

<script>
    import {getAllHorseColors} from "@/swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";
    import CustomMultiSelect from "./inner/CustomMultiSelect.vue";

    export default {
        name: "CustomMultiSelectHorseColor",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            itemLabel: {
                type: String,
                default: "name",
            },
            modelValue: null,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            this.loading = true;
            getAllHorseColors().then((response) => {
                this.items = response.data;
                this.loading = false;
            });
        },

        components: {CustomMultiSelect, CustomSelectOne},
    };
</script>

<style scoped>

</style>
